/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
const t=Symbol("widget"),e=Symbol("widget-test-data");export{t as widgetSymbol,e as widgetTestDataSymbol};
